import {
  PrimaryButtonCss,
  SecondaryButtonCss,
  TextLinkCss,
} from "@/styles/typography";
import { Link } from "gatsby";
import styled from "styled-components";

const PrimaryButton = styled(Link)`
  ${PrimaryButtonCss}
`;

const SecondaryButton = styled(Link)`
  ${SecondaryButtonCss}
`;

const TextLink = styled(Link)<{ $color?: string }>`
  ${TextLinkCss}
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: 100%;
  text-decoration: none;
  color: ${({ $color, theme }) =>
    $color === "light" ? theme.colors.coreLight : theme.colors.textBody};
  text-decoration: underline;
  text-decoration-color: transparent;
  transition: 0.3s;

  svg {
    margin-bottom: 2px;
    height: 22px;
    width: 22px;
    transition: all 0.3s ease-in-out;
    path {
      stroke: ${({ $color, theme }) =>
        $color === "light" ? theme.colors.coreLight : theme.colors.textBody};
    }
  }

  &:hover {
    text-decoration-color: ${({ $color, theme }) =>
      $color === "light" ? theme.colors.coreLight : theme.colors.textBody};

    svg {
      transform: translateX(10px);
    }
  }
`;

const SmallTextLink = styled(TextLink)<{ $color?: string }>`
  font-size: 12px;
  display: flex;
  align-items: center;
  line-height: 0;
  color: ${({ $color, theme }) =>
    $color === "light" ? theme.colors.coreLight : theme.colors.textBody};
  text-decoration: underline;
  text-decoration-color: transparent;
  transition: 0.3s;

  svg {
    margin-bottom: 2px;
    height: 18px;
    width: 18px;
    transition: all 0.3s ease-in-out;
    path {
      stroke: ${({ $color, theme }) =>
        $color === "light" ? theme.colors.coreLight : theme.colors.textBody};
    }
  }

  &:hover {
    text-decoration-color: ${({ $color, theme }) =>
      $color === "light" ? theme.colors.coreLight : theme.colors.textBody};

    svg {
      transform: translateX(10px);
    }
  }
`;

const S = {
  PrimaryButton,
  SecondaryButton,
  TextLink,
  SmallTextLink,
};

export default S;
